<template>
  <div class="entry-wrapper">
    <div class="entry-inner container-wrapper">
      <div class="left-tree search-tree">
        <SearhTree
          class="topic-tree"
          :topicCategorys="topicCategorysItem"
          :defaultExpandedKeys="defaultExpandedKeys"
        >
          <span class="tree-title-style">专题聚类</span>
        </SearhTree>
        <SearhTreeBook class="area-tree" :topicCategorys="areaCategorysItem">
          <span class="tree-title-style">地区聚类</span>
        </SearhTreeBook>
      </div>
      <div class="right-main" v-if="itemList.resulter">
        <bread-crumb :totalItems="itemList.resulter.hit"></bread-crumb>
        <div class="filter-list">
          <div class="filter">
            筛选条件：
            <span
              class="iconfont"
              @click="handleRemoveFilter(index, item)"
              v-for="(item, index) of this.filterList"
              :key="index"
              >{{
                item.split(":")[1] | installFilterName
              }}&nbsp;&nbsp;&#xe785;</span
            >
          </div>
          <span
            class="Date"
            @click="handleSort('0')"
            :class="{ active: this.sortType === '0' }"
            >按出版时间</span
          >
          <span
            class="BookTitle"
            @click="handleSort('1')"
            :class="{ active: this.sortType === '1' }"
            >按书名</span
          >
        </div>
        <div class="item-list" v-if="itemList.resulter.hit">
          <div
            class="item"
            v-for="(item, index) of JSON.parse(itemList.resulter.results)"
            :key="index"
          >
            <div class="item-title">
              <div
                class="title"
                @click="handleItemRead(item.Id)"
                v-html="
                  `${
                    index +
                    1 +
                    itemList.resulter.pageSize * (itemList.resulter.curPage - 1)
                  }.${item.Title_HL || item.Title}`
                "
              ></div>
              <span class="downing" @click="handleItemDown(item.Id)">下载</span>
              <span class="reading" @click="handleItemRead(item.Id)">阅读</span>
            </div>
            <div class="item-message">
              <div class="message-1" v-if="item.BookTitle">
                来&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;源：<span
                  v-html="item.BookTitle_HL || item.BookTitle"
                  :title="item.BookTitle"
                  @click="handleDetail(item.BookID)"
                ></span>
              </div>
              <div
                class="message-2"
                v-if="item.Province || item.City || item.County"
              >
                地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;区：
                <span
                  :title="
                    (item.Province || '') +
                    (item.City || '') +
                    (item.County || ')')
                  "
                  >{{ item.Province }}{{ item.City }}{{ item.County }}</span
                >
              </div>
              <div class="message-3" v-if="item.Publisher">
                出版单位：<span
                  :title="item.Publisher"
                  v-html="item.Publisher_HL || item.Publisher"
                ></span>
              </div>
              <div class="message-4" v-if="item.Date">
                出版时间：<span :title="item.Date">{{ item.Date }}</span>
              </div>
              <div class="message-5" v-if="item.Editorial">
                编纂单位：<span
                  :title="item.Editorial"
                  v-html="item.Editorial_HL || item.Editorial"
                ></span>
              </div>
            </div>
            <p
              class="item-content"
              v-if="item.Content"
              v-html="item.Content_HL || item.Content"
            ></p>
          </div>
        </div>
        <div class="searchWarn" v-else>
          <i class="wf-icon icon-information"></i>
          没有命中记录，请重试或修改检索表达式
        </div>
        <Paganition
          v-if="itemList.resulter.totalPage > 1"
          :total="this.itemList.resulter.hit"
          :currentPage="itemList.resulter.curPage"
          :pageSize="itemList.resulter.pageSize"
          :totalPage="itemList.resulter.totalPage"
          @size-change="handleUpdateData()"
          @handleCurrentChangeSub="handleCurrentChangeSub"
          name="pagination"
        >
        </Paganition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Paganition from '../../components/Pagination/Pagination'
import SearhTree from '../../components/treeList/SearhTree'
import SearhTreeBook from '../../components/treeList/SearhTreeBook'
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb'
import { READ_URL, RESOURCE_TYPE_ITEM_READ, LOGIN_IN_URL, RESOURCE_TYPE_ITEM_DOWN } from '../../assets/constant'
export default {
  name: 'Entry',
  data () {
    return {
      opt: {
        fq: [],
        pageNo: 1,
        pageSize: 10,
        sorts: []
      },
      defaultExpandedKeys: [],
      // 上一个节点的信息
      lastTreeNodeId: 0,
      lastSubNodes: 0,
      totalIndex: 0,
      isShowAll: true,
      currentIndex: -1,
      curPage: 1,
      filterArray: [],
      sortType: '0'
    }
  },
  filters: {
    installFilterName (val) {
      if (val.indexOf('#') !== -1) {
        return val.split('#').join(': ')
      } else {
        return val
      }
    }
  },
  components: {
    Paganition,
    SearhTree,
    BreadCrumb,
    SearhTreeBook
  },
  mounted() {
    if (this.$loginAuthentication.intercept(0)) {
      this._reqRouterQuery()
      this.$store.dispatch('getTopicCategoryItem', { core: 'LocalChronicleItemEdu', facetPivot: ['CategoryA', 'CategoryB'], query: this.$route.query.query, fq: this.opt.fq })
      this.$store.dispatch('getAreaCategoryItem', { core: 'LocalChronicleItemEdu', facetPivot: ['Province'], query: this.$route.query.query, fq: this.opt.fq })
      this.$store.dispatch('getItemList', this.opt)
      this.addFilter()
    }
  },
  methods: {
    // 条目下载
    async handleItemDown(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        // 3 条目下载
        this.$store.dispatch('savSourceType', 3)
        if (this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_DOWN);
        } else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    // 条目阅读
    async handleItemRead(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$store.dispatch('savSourceType', 1)
        if (this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_READ);
        } else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.location.href
        }
      }
    },
    async handleSort(val) {
      if (await this.$loginAuthentication.intercept(0)) {
        this._reqRouterQuery()
        this.sortType = val
        this.opt.sorts = this.sortType === '1' ? [{ feild: 'BookTitle', order: 'desc' }] : [{ feild: 'Date', order: 'desc' }]
        this.opt.pageNo = 1
        this._replaceRouterParam(this.opt)
        // this.$store.dispatch('getItemList', this.opt)
      }
    },
    // 筛选条件
    addFilter () {
      this.filterArray = []
      // this.filterArray = new Set(this.filterArray);
      if (this.$route.query.CategoryA) {
        this.filterArray.push(this.$route.query.CategoryA)
      }
      if (this.$route.query.CategoryB) {
        this.filterArray.push(this.$route.query.CategoryB)
      }
      if (this.$route.query.Province) {
        this.filterArray.push(this.$route.query.Province)
      }
      this.filterArray = new Set(this.filterArray)
      this.filterArray = Array.from(this.filterArray)
    },
    async handleRemoveFilter(index, item) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.filterList.splice(index, 1)
        localStorage.setItem(`filterList`, JSON.stringify(this.filterList))
        this._reqRouterQuery()
        this.$store.dispatch('getItemList', this.opt)
        this.$store.dispatch('getTopicCategoryItem', { core: 'LocalChronicleItemEdu', facetPivot: ['CategoryA', 'CategoryB'], query: this.$route.query.query, fq: this.filterList })
        this.$store.dispatch('getAreaCategoryItem', { core: 'LocalChronicleItemEdu', facetPivot: ['Province'], query: this.$route.query.query, fq: this.filterList })
        const totalIndex = this.$route.query.totalIndex
        const pageNo = this.$route.query.pageNo
        const CategoryA = this.$route.query.CategoryA
        const CategoryB = this.$route.query.CategoryB
        const Province = this.$route.query.Province
        //const query = this.$route.query.query
        this.$router.replace({
          path: 'searchItem',
          query: {
            CategoryA: item === CategoryA ? '' : CategoryA || '',
            CategoryB: item === CategoryB ? '' : CategoryB || '',
            totalIndex: totalIndex || '',
            Province: item === Province ? '' : Province || '',
            pageNo: pageNo || 1,
            query: query || '',
            clear: 1
          }
        })
      }
    },
    _reqRouterQuery () {
      const CategoryA = this.$route.query.CategoryA || ''
      const CategoryB = this.$route.query.CategoryB || ''
      const Province = this.$route.query.Province || ''
      const pageNo = this.$route.query.pageNo || 1
      const query = this.$route.query.query || ''
      const sortType = this.$route.query.sortType || '0'
      const fq = []
      let cat = ''
      if (CategoryB !== '') {
        cat = `CategoryB:${CategoryA}#${CategoryB}`
        fq.push(cat)
      }
      if (CategoryA !== '' && CategoryB === '') {
        cat = `CategoryA:${CategoryA}`
        fq.push(cat)
      }
      if (Province !== '') {
        cat = `Province:${Province}`
        fq.push(cat)
      }
      this.opt.fq = this.filterList
      this.opt.pageNo = pageNo || 1
      this.opt.query = query || ''
      this.opt.sorts = sortType !== '0' ? [{ feild: 'BookTitle', order: 'desc' }] : [{ feild: 'Date', order: 'desc' }]
      this.opt.core = 'LocalChronicleItemEdu'
      this.sortType = sortType
    },
    _replaceRouterParam (opt) {
      const CategoryA = this.$route.query.CategoryA
      const CategoryB = this.$route.query.CategoryB
      const Province = this.$route.query.Province
      const totalIndex = this.$route.query.totalIndex
      const pageNo = this.$route.query.pageNo
      const query = this.$route.query.query
      this.$router.replace({
        path: 'searchItem',
        query: {
          CategoryA: CategoryA || '',
          CategoryB: CategoryB || '',
          totalIndex: totalIndex || '',
          Province: Province || '',
          pageNo: opt.pageNo || pageNo,
          query: opt.query || query,
          sortType: this.sortType
        }
      })
    },
    handleCurrentSelect (index, value) {
      this.currentIndex = index
      const CategoryA = this.$route.query.CategoryA
      const CategoryB = this.$route.query.CategoryB
      const totalIndex = this.$route.query.totalIndex
      this.$router.replace({
        path: 'searchItem',
        query: {
          CategoryA: CategoryA || '',
          CategoryB: CategoryB || '',
          totalIndex: totalIndex || '',
          Province: value
        }
      })
    },
    _initTopicCategory () {
      const CategoryA = this.$route.query.CategoryA || ''
      const CategoryB = this.$route.query.CategoryB || ''
      const fq = []
      let cat = ''
      if (CategoryB !== '') {
        cat = `CategoryB:${CategoryA}#${CategoryB}`
        fq.push(cat)
      }
      if (CategoryA !== '' && CategoryB === '') {
        cat = `CategoryA:${CategoryA}`
        fq.push(cat)
      }
      // this.opt.fq = fq
      return fq
    },
    // 当前页改变触发
    async handleCurrentChangeSub(val) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.opt.pageNo = val
        this._replaceRouterParam(this.opt)
      }
    },
    // 跳转志书详情页
    async handleDetail(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.push({
          path: '/detail',
          query: { BookID: id }
        })
      }
    }
  },
  computed: {
    ...mapState(['topicCategorysItem', 'areaCategorysItem', 'itemList', 'userinfo', 'filterList'])
  },
  watch: {
    // 监听主题分类参数
    '$route.query.query' () {
      for (var i = 0; i < this.filterList.length; i++) {
        this.filterList.splice(i, 1)
      }
      localStorage.setItem(`filterList`, JSON.stringify(this.filterList))
    },
    $route: {
      handler: function (val) {
        if (this.$loginAuthentication.intercept(0)) {
          this._reqRouterQuery()
          this.$store.dispatch('getItemList', this.opt)
          this.$store.dispatch('getTopicCategoryItem', { core: 'LocalChronicleItemEdu', facetPivot: ['CategoryA', 'CategoryB'], query: this.$route.query.query, fq: this.filterList })
          this.$store.dispatch('getAreaCategoryItem', { core: 'LocalChronicleItemEdu', facetPivot: ['Province'], query: this.$route.query.query, fq: this.filterList })
          this.addFilter()
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.entry-wrapper {
  background: #e9edf0;
  min-height: 800px;
  // padding-bottom: 38px;
  &::after {
    content: "";
    position: absolute;
    background: url("../../assets/imgs/bg-lf.png") no-repeat;
    width: 204px;
    height: 226px;
    top: 680px;
  }
  &::before {
    content: "";
    position: absolute;
    background: url("../../assets/imgs/bg-rt.png") no-repeat;
    width: 204px;
    height: 226px;
    top: 920px;
    right: 0;
  }
  .entry-inner {
    position: relative;
    z-index: 1;
    overflow: hidden;
    background: #fff;
    min-height: 800px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
.left-tree {
  width: 240px;
  float: left;
}
.topic-tree,
.area-tree {
  float: left;
  width: 240px;
  background: #f4f4f4;
  box-sizing: border-box;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
}
.elipse () {
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.right-main {
  float: right;
  margin-right: 20px;
  min-height: 800px;
  margin-top: 12px;
  width: 860px;
  margin-right: 30px;
  margin-left: 30px;
  position: relative;
  .searchWarn {
    font-size: 18px;
    text-align: center;
    margin-top: 250px;
  }
  .filter-list {
    .filter {
      display: inline-block;
      margin-left: 25px;
      height: 20px;
      margin-top: 20px;
      width: 640px;
      span {
        display: inline-block;
        height: 28px;
        border: 1px solid #d5ddec;
        padding: 0 12px;
        margin-right: 8px;
        margin-bottom: 5px;
      }
    }
    min-height: 60px;
    background: #f5f8ff;
    vertical-align: middle;
    &::after {
      content: "";
      height: 100%;
      display: inline-block;
      vertical-align: middle;
    }
    span {
      display: inline-block;
      border: 1px solid rgba(105, 124, 164, 1);
      border-radius: 4px;
      vertical-align: middle;
      line-height: 28px;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      color: rgba(23, 67, 165, 1);
      cursor: pointer;
      &.active {
        background: rgba(23, 67, 165, 1);
        color: #fff;
      }
      &.Date {
        width: 100px;
        height: 28px;
        margin-right: 10px;
        margin-left: 6px;
        float: right;
        margin-top: 15px;
        &:hover {
          background: rgba(23, 67, 165, 1);
          color: #fff;
        }
      }
      &.BookTitle {
        width: 75px;
        height: 28px;
        float: right;
        margin-top: 15px;
        &:hover {
          background: rgba(23, 67, 165, 1);
          color: #fff;
        }
      }
    }
  }
  .top-list-area {
    width: 880px;
    overflow: hidden;
    background: #f5f8ff;
    margin-right: 20px;
    margin-bottom: 10px;
    .topic-list-title {
      font-weight: bold;
      color: #333333;
      line-height: 32px;
      padding-top: 15px;
      margin-left: 17px;
      margin-bottom: 5px;
      margin-right: 9px;
      overflow: hidden;
      .text-icon {
        float: left;
        font-size: 14px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
      .btn-export {
        float: right;
        width: 76px;
        background: rgba(239, 243, 251, 1);
        border: 1px solid rgba(105, 124, 164, 1);
        border-radius: 4px;
      }
    }
  }
  .item-list {
    padding-bottom: 100px;
    .item {
      width: 860px;
      padding-top: 15px;
      padding-bottom: 20px;
      border-bottom: 1px dotted #dddddd;
    }
    .item-title {
      background: url("../../assets/imgs/item-title-bg.png") no-repeat;
      background-position: left center;
      overflow: hidden;
      height: 30px;
      line-height: 30px;
      overflow: hidden;
      margin-bottom: 20px;
      padding-left: 25px;
      font-size: 16px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      div {
        display: inline-block;
        vertical-align: middle;
      }
      span {
        float: right;
        width: 76px;
        height: 28px;
        border-radius: 14px;
        text-align: center;
        font-size: 13px;
        color: #1743a5;
        background-color: #f5f8ff;
        margin-left: 10px;
        background: rgba(245, 248, 255, 1);
        border: 1px solid rgba(105, 124, 164, 1);
        border-radius: 14px;
        cursor: pointer;
        font-weight: 400;
        &:hover {
          background: #4160a5;
          color: #ffffff;
        }
        &.active {
          background: rgba(65, 96, 165, 1);
          color: #ffffff;
        }
      }
      .title {
        max-width: 638px;
        vertical-align: middle;
        .elipse();
        font-size: 16px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        // line-height:30px;
        cursor: pointer;
        &:hover {
          color: #1743a5;
          text-decoration-line: underline;
        }
      }
    }
    .item-message {
      font-size: 13px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      overflow: hidden;
      width: 873px;
      div {
        margin-right: 38px;
      }
      div,
      span {
        display: inline-block;
        vertical-align: middle;
        height: 24px;
        line-height: 24px;
      }
      span {
        font-weight: normal;
        height: 100%;
        margin-top: -2px;
      }
      .message-1 {
        width: 260px;
        span {
          cursor: pointer;
          width: 180px;
          .elipse();
          &:hover {
            color: #4160a5;
            text-decoration: underline;
          }
          &.active {
            color: rgba(65, 96, 165, 1);
            text-decoration: underline;
          }
        }
      }
      .message-2 {
        width: 230px;
        span {
          width: 130px;
          .elipse();
        }
      }
      .message-3 {
        span {
          width: 174px;
          .elipse();
        }
      }
      .message-4 {
        width: 260px;
        span {
          width: 180px;
          .elipse();
        }
      }
      .message-5 {
        max-width: 570px;
        span {
          max-width: 485px;
          .elipse();
        }
      }
    }
    .item-content {
      margin-top: 10px;
      max-height: 36px;
      width: 873px;
      color: #666666;
      line-height: 19px;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
.search-tree {
  float: left;
  background: #f4f4f4;
  margin: 0 20px;
  padding-bottom: 9000px;
  margin-bottom: -9000px;
}
</style>



// WEBPACK FOOTER //
// src/pages/SearchItem/SearchItem.vue